import type { TeamChatEmbed } from '../../lib/teamChatApi';
import { AttachmentImage } from '../ui/AttachmentImage';
import { SmartLink } from '../ui/SmartLink';

/** Discord-style link preview card built from server-side OG unfurl data. */
export function EmbedCard({ embed }: { embed: TeamChatEmbed }) {
  let host = '';
  try {
    host = new URL(embed.url).hostname;
  } catch {
    host = embed.url;
  }
  return (
    <SmartLink
      href={embed.url}
      className="mt-1.5 flex max-w-md gap-3 rounded-md border-l-4 border-brand-600 bg-accent/50 p-3 transition-colors hover:bg-accent"
    >
      <span className="min-w-0 flex-1">
        <span className="block truncate text-xs text-muted-foreground">
          {embed.siteName || host}
        </span>
        {embed.title && (
          <span className="mt-0.5 block truncate text-sm font-semibold text-brand-600">
            {embed.title}
          </span>
        )}
        {embed.description && (
          <span className="mt-0.5 line-clamp-2 block text-xs text-muted-foreground">
            {embed.description}
          </span>
        )}
      </span>
      {embed.imageUrl && (
        <span className="h-16 w-16 shrink-0">
          {/* Decorative thumbnail of the linked page: the click belongs to the
              surrounding link, not to a zoom. */}
          <AttachmentImage
            src={embed.imageUrl}
            alt=""
            className="h-16 w-16 rounded object-cover"
            placeholderClassName="h-16 w-16"
            zoomable={false}
          />
        </span>
      )}
    </SmartLink>
  );
}
